import { useCallback } from "react";
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

const ParticlesBackground = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
  }, []);

  return (
<div className="relative w-full h-full bg-black galaxy-bg">
  
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          background: {
            color: {
              value: "transparent",
            },
          },
          fpsLimit: 160,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "push",
              },
              onHover: {
                enable: true,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              push: {
                quantity: 15,
              },
              repulse: {
                distance: 200,
                duration: 0.2,
              },
            },
          },
          particles: {
            color: {
              value: "#fefdfe",
              animation: {
                enable: true,
                speed: 1,
                sync: true,
              },
            },
            links: {
              color: "#fdfdfa",
              distance: 150,
              enable: false,
              opacity: 0.5,
              width: 1,
            },
            move: {
              direction: "none",
              enable: true,
              outModes: {
                default: "out",
              },
              random: false,
              speed: 0.3,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 800,
              },
              value: 80,
            },
            opacity: {
              value: 1,
              animation: {
                enable: true,
                speed: 1,
                minimumValue: 0.1,
                sync: true,
              },
            },
            shape: {
              type: "circle",
            },
            size: {
              value: { min: 1, max: 5 },
            },
          },
          detectRetina: true,
          emitters: [
            {
              direction: "random",
              rate: {
                quantity: 1,
                delay: 3,
              },
              size: {
                width: 100,
                height: 10,
              },
              position: {
                x: 50,
                y: 100,
              },
            },
            {
              direction: "right",
              speed: 10,
              rate: {
                quantity: 1,
                delay: 2,
              },
              size: {
                width: 0,
                height: 0,
              },
              position: {
                x: 0,
                y: 50,
              },
            },
          ],
        }}
      />
    </div>
  );
};

export default ParticlesBackground;
